export const FAQ: { q: string; a: string }[] = [
  {
    q: "What is the EFL Interactive Companion?",
    a: "It is a set of interactive lessons that go with the Everything for Life video course from Nathaniel School of Music. Each lesson adds playable notation, real piano sound, ear trainers and practice tools to the video.",
  },
  {
    q: "Who is it for?",
    a: "It is for students of the Everything for Life course who want to practise what they learn in the videos. It covers 156 lessons across 9 courses, including Ear Training, Sing & Play, Staff Notation and the South Indian Songbook.",
  },
  {
    q: "Is it free?",
    a: "The companion is included with Everything for Life, which is a one-time payment of $299 for lifetime access. You open it from your lesson page after you log in.",
  },
  {
    q: "Does it work on a phone or a Mac?",
    a: "Yes. The companion runs in a normal web browser, so there is nothing to install.",
  },
  {
    q: "Who made it?",
    a: "It was made by Nathaniel School of Music, founded by Jason Zac in Bangalore, India.",
  },
];
